"use client";

import { useEffect, useState } from "react";

const features = [
  {
    title: "Live Interactive Classes",
    description: "Real-time doubt clearing sessions with IIT Kanpur mentors",
    icon: "📹",
  },
  {
    title: "Comprehensive Study Materials",
    description:
      "Meticulously curated notes and problem sets covering entire syllabus",
    icon: "📚",
  },
  {
    title: "Practice Tests & Quizzes",
    description:
      "Regular assessments to track progress and identify weak areas",
    icon: "✍️",
  },
  {
    title: "Personalized Mentoring",
    description: "One-on-one guidance sessions with experienced mentors",
    icon: "👨‍🏫",
  },
  {
    title: "Lifetime Access",
    description: "Access to all course materials and recordings forever",
    icon: "♾️",
  },
  {
    title: "Community Support",
    description: "Active community forum for peer discussions and networking",
    icon: "👥",
  },
];

export default function Features() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="features" className="py-20 bg-white px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div
          className={`text-center mb-16 ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-pretty">
            Why Choose{" "}
            <span className="text-[var(--primary-color)]">Machine Academy</span>
          </h2>
          <p className="text-lg text-[#5c5c5c] max-w-2xl mx-auto">
            We provide everything you need to excel in your chemistry exam
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl border border-[#193cb843] p-8 hover:border-[var(--primary-color)] transition-all duration-300 ${
                isVisible ? "animate-fade-in-up" : "opacity-0"
              }`}
              style={{ animationDelay: isVisible ? `${index * 0.1}s` : "0s" }}
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold mb-3 text-foreground">
                {feature.title}
              </h3>
              <p className="text-[#5c5c5c]">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
